import styled from '@emotion/styled';

const COLOR = '#464B50';

interface Props {
    isSelected?: boolean;
}

function RadioCircle({ isSelected }: Props) {
    return (
        <Wrapper>
            <Circle>
                <Dot isSelected={isSelected} />
            </Circle>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 2px;
`;

const Circle = styled.div`
    align-items: center;
    border: 2px solid ${COLOR};
    border-radius: 10px;
    display: flex;
    height: 18px;
    justify-content: center;
    position: relative;
    transition: border-color 100ms linear;
    width: 18px;
`;

const Dot = styled.div<{
    isSelected?: boolean;
}>`
    background-color: ${COLOR};
    border-radius: 6px;
    height: 8px;
    position: absolute;
    transform: ${({ isSelected }) => (isSelected ? 'scale(1)' : 'scale(0)')};
    transition:  150ms linear;
    width: 8px;
`;

export default RadioCircle;
